import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['modalContainer', 'modalBlanket', 'closeBtn']

  showWidgetBookableBox() {
    this.closeModal()
    this.bookableBoxController.showBookableBox()
  }

  closeModal() {
    const modalElements = [this.modalContainerTarget, this.modalBlanketTarget]

    modalElements.forEach((e) => {
      e.style.display = 'none';
    });
  }

  get bookableBoxController() {
    return this.getControllerByIdentifier("widget--box")
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }
}
